import { useGetTeamCompetitionsQuery } from '../state/api';
import { selectTeamCompetitionById } from '../state/entitySelectors';
import { useAppSelector } from '../hooks/reduxHooks';
import TeamCompetitionOverview from './team-competition-overview';

interface TeamCompetitionOverviewContainerProps {
  compID: string;
}

const TeamCompetitionOverviewContainer = ({ compID }: TeamCompetitionOverviewContainerProps) => {
  // Fetch data with RTK Query (handles caching, loading states)
  // Use withCompetitors: true for consistency with other components
  useGetTeamCompetitionsQuery({ withCompetitors: true });

  // Use entity selector for O(1) lookup by ID (no more useMemo or array.find!)
  // Pass true for withCompetitors to match the query
  const teamComp = useAppSelector((state) => selectTeamCompetitionById(state, compID, true));

  return <TeamCompetitionOverview teamComp={teamComp} />;
};

export default TeamCompetitionOverviewContainer;
